import ShippingUPSBox from "./ShippingUPSBox";
import ShippingBoxUSPS from "./ShippingUSPS";

const normalizeUpsName = (name = "") =>
  name.replace(/®/g, "").replace(/\s+/g, " ").trim().toLowerCase();

const classifyUpsService = (name = "") => {
  const normalized = normalizeUpsName(name);
  if (normalized.includes("next day air")) return "Next Day Air";
  if (
    normalized.includes("2nd day air") ||
    normalized.includes("second day air")
  ) {
    return "2nd Day Air";
  }
  if (normalized.includes("3 day select")) return "3 Day Select";
  if (normalized.includes("ground")) return "Ground";
  return null;
};

const parseDeliveryDate = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }
  if (/^\d{8}$/.test(value)) {
    const year = Number(value.slice(0, 4));
    const month = Number(value.slice(4, 6));
    const day = Number(value.slice(6, 8));
    return new Date(year, month - 1, day);
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const Results = (props) => {
  const upsMap = new Map();

  (Array.isArray(props.ups) ? props.ups : []).forEach((service) => {
    const rawName = service?.Service?.Description || service?.service || "";
    const serviceName = classifyUpsService(rawName);
    const expectedDelivery =
      service?.EstimatedArrival?.Arrival?.Date || service?.deliveryDate;
    const parsedDate = parseDeliveryDate(expectedDelivery);

    if (!serviceName || !expectedDelivery || !parsedDate) {
      return;
    }

    const existing = upsMap.get(serviceName);
    if (!existing || parsedDate < existing.parsedDate) {
      upsMap.set(serviceName, {
        service: serviceName,
        expectedDelivery,
        parsedDate,
      });
    }
  });

  const ups = Array.from(upsMap.values()).sort(
    (a, b) => a.parsedDate - b.parsedDate
  );

  return (
    <>
      <div className="mb-10 flex w-full flex-wrap justify-center gap-4 px-4">
        {(Array.isArray(props.services) ? props.services : []).map(
          (service, i) => {
            return (
              <ShippingBoxUSPS
                key={i}
                service={service.service}
                expectedDelivery={service.deliveryDate}
                weather={props.weather}
                low={props.low}
                high={props.high}
                tempUnit={props.tempUnit}
              />
            );
          }
        )}
      </div>
      <div className="mb-20 flex w-full flex-wrap justify-center gap-4 px-4">
        {ups.map((service, i) => {
          return (
            <ShippingUPSBox
              key={i}
              service={service.service}
              expectedDelivery={service.expectedDelivery}
              weather={props.weather}
              low={props.low}
              high={props.high}
              tempUnit={props.tempUnit}
            />
          );
        })}
      </div>
    </>
  );
};

export default Results;
